<template>
  <router-link :to="{name: $routeNames.main.profile}" :class="classes">
    <figure class="app-logo d-flex align-center justify-center">
      <img
        :src="customLogo ? customLogo : getImgUrl(defaultLogo)"
        alt="logotype"
        class="app-logo__img"
        :class="{'no-print': !v.isShare}"
      />
      <img
        v-if="v.isPrint"
        :src="reportParams[reportLogo] || defaultReportLogo"
        alt="logotype"
        class="app-logo__img print"
      />
    </figure>
  </router-link>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import {gettersTypes as settingsGettersTypes} from '@/store/modules/settings/getters';
import variables from '@/helpers/variables';

export default {
  name: 'AppLogo',
  props: {
    classes: {
      required: false,
      type: String,
      default: null,
    },
    darkLogo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      v: variables,
      defaultLogo: this.darkLogo ? 'logo.svg' : 'logo-white.svg',
      reportLogo: this.darkLogo ? 'report_logo_black' : 'report_logo_white',
    };
  },
  computed: {
    ...mapGetters({
      reportParams: settingsGettersTypes.reportParams,
      reportLogoBlack: settingsGettersTypes.reportLogoBlack,
      reportLogoWhite: settingsGettersTypes.reportLogoWhite,
    }),
    ...mapState({
      instance: (state) => state.settings.instance,
    }),
    defaultReportLogo() {
      return this.darkLogo ? this.reportLogoBlack : this.reportLogoWhite;
    },
    customLogo() {
      const {instance} = this;
      const {path} = this.$route;

      if (!instance) return null;

      return (path.startsWith('/authentication') && instance.auth_logo_url) || instance.logo_url;
    },
  },
  methods: {
    getImgUrl(name) {
      return require(`@/assets/img/${name}`);
    },
  },
};
</script>

<style scoped lang="scss">
.app-logo {
  &__img {
    width: 100%;
    height: auto;
    max-height: rem(80px);
    object-fit: contain;
  }
}
</style>
